import { BrandQueryOutput } from '../queries'

export const dedupeBrandOfferIds = (data: BrandQueryOutput | undefined) => {
  const dedupeIds = data?.Brands?.docs?.[0]?.content?.reduce((acc, curr) => {
    if ('offers' in curr) {
      const offers = curr.offers as any[]
      return [...acc, ...offers.map((offer) => offer.id)]
    }

    if ('offer' in curr && curr.offer) {
      const offer = curr.offer as any
      return [...acc, offer.id]
    }

    return acc
  }, [] as string[])

  return dedupeIds
}
